<div class="experienceCard experienceCard--fixed cursor-pointer h-full" *ngIf="experience">

    <p-card [style]="{ height: '420px' }">
        <ng-template pTemplate="header">
            <div class="headCard flex justify-content-between"
                [appImageFallback]="getCardImageUrl()">
                <div class="tags">
                    <ng-container *ngFor="let tag of experience.dws_tags">
                        <span class="text-xs tag"
                            *ngIf="showTag(tag)">{{
                            '#' + tag.name }}</span>
                    </ng-container>
                </div>
                <div class="favorites" (click)="addToFavorites($event)">
                    <i [class]="'pi text-2xl text-white ' + (isFavorite ? 'pi-heart-fill' : 'pi-heart')"></i>
                </div>
            </div>
        </ng-template>

        <div class="experience-card__lower">
            <div class="card-body">
                <h3
                    class="experience-title text-ellipsis-2"
                    [title]="experience.details?.title || experience.title"
                >
                    {{ experience.details?.title || experience.title }}
                </h3>
            </div>

            <div class="prices">
                <div class="price">
                    <span>{{ formatCurrencyCents(experience.prices?.[0]?.priceCents || experience.price_cents) }}</span> <span> / {{
                        maxLenghtText(experience.prices?.[0]?.description || '', 30) || 'Adulti'}} </span>
                </div>
            </div>

            <div class="winery flex justify-content-between">
                <span class="text-sm nameCity"><i class="pi pi-map-marker" style="font-size: 0.9rem"></i> {{
                    (experience.details?.place?.city || experience.city || '---') }} ({{ experience.details?.place?.province || experience.province || '---' }})</span>
                <span class="text-sm nameCompany"><i class="pi pi-exclamation-circle" style="font-size: 0.9rem"></i> {{
                    experience.company?.name || 'company da definire' }}</span>
            </div>
        </div>
    </p-card>
</div>
<!-- LOADER -->
<div class="card" *ngIf="!experience">
    <div class="experienceCard experienceCard--fixed cursor-pointer">
        <p-card [style]="{ height: '420px' }">
            <div class="flex mb-3">
                <p-skeleton shape="circle" size="4rem" styleClass="mr-2"></p-skeleton>
                <div>
                    <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
                    <p-skeleton height=".5rem"></p-skeleton>
                </div>
            </div>
            <p-skeleton width="100%" height="240px"></p-skeleton>
            <div class="flex justify-content-between mt-3">
                <p-skeleton width="4rem" height="2rem"></p-skeleton>
                <p-skeleton width="4rem" height="2rem"></p-skeleton>
            </div>
        </p-card>
    </div>

</div>
